/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { Button, theme } from "@nordcloud/gnui";
import { BreadcrumbsBox } from "~/components";
import { ROUTES } from "~/routing/routes";
import { CloudAccount } from "../types";
import { getAccountDisplayName, isVMWare } from "../utils";

type Props = {
  tags: { color: string; text: string }[];
  account: CloudAccount;
  openCredentialsUpdateSteps: () => void;
  showUpdateCredentials: boolean;
};

export function Header({
  tags,
  account,
  openCredentialsUpdateSteps,
  showUpdateCredentials,
}: Props) {
  const accountName = getAccountDisplayName(account);
  const breadcrumbLabels = [
    { uri: ROUTES.index, label: "Home" },
    { uri: ROUTES.cloudAccounts.index, label: "Cloud Accounts" },
    { uri: ROUTES.cloudAccounts.details, label: accountName },
  ];

  return (
    <BreadcrumbsBox
      title={accountName}
      tags={tags}
      customBreadcrumbs={breadcrumbLabels}
    >
      <When condition={isVMWare(account?.providerType)}>
        <Button
          icon="externalLink"
          css={{ marginRight: theme.spacing.spacing01 }}
          linkTo="https://docs.mca.nordcloudapp.com/docs/visibility/cloud-accounts/vmware/add-vmware"
        >
          Instructions
        </Button>
      </When>
      <When condition={showUpdateCredentials}>
        <Button
          ml={theme.spacing.spacing02}
          icon="edit"
          onClick={openCredentialsUpdateSteps}
        >
          Update Credentials
        </Button>
      </When>
    </BreadcrumbsBox>
  );
}
